import React from "react";

import botanacorLogo from "../../assets/images/botanacor-logo.svg";
import classes from "./Logo.module.css";

const logo = () => (
  <div className={classes.Logo}>
    <img src={botanacorLogo} alt="Botanacor Logo" />
  </div>
);

export default logo;
